// extracted by mini-css-extract-plugin
module.exports = {"footer-legal-link":"footerLegalLinks_footer-legal-link__GOCwc","footerLegalLink":"footerLegalLinks_footer-legal-link__GOCwc"};